import React, { useState } from 'react';
import Link from 'gatsby-link';
import classNames from 'classnames';
import { withPrefix } from 'gatsby';
import styles from './MobileMenu.styles';

const MobileMenu = ({ articles, locationPathName }) => {
  const [active, setActive] = useState(false);

  return (
    <div css={styles}>
      <div className={classNames('menu-btn', { 'position-on-top': active })} onClick={() => setActive(!active)}>
        <div className="bars">
          <div className={classNames('bar-first', { 'bar-first--active': active })} />
          <div className={classNames('bar-second', { 'bar-second--active': active })} />
          <div className={classNames('bar-third', { 'bar-third--active': active })} />
        </div>
      </div>
      <div className={classNames('mobile-menu', { show: active })}>
        <div className="mobile-menu__content">
          {articles &&
            articles.map((article) =>
              article.dropDownList ? (
                <div key={article.href + article.name}>
                  <div
                    dangerouslySetInnerHTML={{ __html: article.name }}
                    className={'article-link article-link--padding-bottom'}
                  />
                  <div className="mobile-menu__submenu">
                    {article.dropDownList.map((item) => (
                      <div key={item.href + item.title}>
                        {item.title && <p className="mobile-menu__submenu-title">{item.title}</p>}
                        <Link
                          to={item.href}
                          key={item.href + item.title}
                          className={classNames('mobile-menu__link-navigation', {
                            'mobile-menu__link-navigation--active': locationPathName === withPrefix(item.href),
                          })}>
                          {item.name}
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <Link
                  to={article.href}
                  key={article.href + article.name}
                  className={classNames('article-link', {
                    'article-link--active': locationPathName === withPrefix(article.href),
                  })}>
                  {article.name}
                </Link>
              )
            )}
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
